import { Box } from "@mui/material";

import "./index.css";
import Front from './Front';
import Back from './Back';

const cardWidth = 250;

const styles = {
  card: {
    width: `${cardWidth}px`,
    maxWidth: `${cardWidth}px`,
    minWidth: `${cardWidth}px`,
    flex: "1 1 auto",
    margin: "12px",
    transition: "transform 0.6s ease-in-out",
  },
};

const FlippableCard = (props) => {
  const {
    data = {},
    name = "name",
    image = "image",
    color = "color",
    sub = "sub",
    desc = "description",
    icons = "tech",
    flippable = true,
  } = props;

  const cardFlip = (e) => {
    const { currentTarget: card } = e;
    if (flippable) card.classList.toggle("flip");
  };

  const frontProps = { data, name, image, color, sub };
  const backProps = { data, desc, icons };

  const cardStyle = Object.assign({}, styles.card);
  if (flippable) {
    cardStyle.cursor = 'pointer';
  }

  return (
    <Box onClick={cardFlip} className="flipper" sx={cardStyle}>
      <Front {...frontProps} />
      {flippable && <Back {...backProps} />}
    </Box>
  );
};

export default FlippableCard;
